import { render, staticRenderFns } from "./reduce-pay.vue?vue&type=template&id=d0f676ac&scoped=true"
import script from "./reduce-pay.vue?vue&type=script&lang=js"
export * from "./reduce-pay.vue?vue&type=script&lang=js"
import style0 from "./reduce-pay.vue?vue&type=style&index=0&id=d0f676ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f676ac",
  null
  
)

export default component.exports